import LocalBenefit from './LocalBenefit'

export default LocalBenefit
